import React, {useEffect, useState, useMemo} from "react";
import {Field, reduxForm} from "redux-form";
import {useDispatch, useSelector} from "react-redux";
import {isEmpty} from "lodash";
import {getCurrentUser} from "_helpers";
import {msgSourceActions, gorgiasAuthActions} from "_actions";
import {Box} from "@mui/material";
import {modalInnerStyles} from "../../Utilities/basicModalStyles";
import SubdomainInput from "../../Utilities/SubdomainInput";
import SetupModalFooter from "../../Utilities/SetupModalFooter";

function GorgiasSetupForm({description, buttonLabel, channelDomain, extraInfoLabel, openInNewTab, handleSubmit, callbackUrl = `${CLIENT_URL}/signup/add-channel`}){
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(true);
  const gorgias = useSelector(state => state.gorgiasAuth);
  const loading = useMemo(() => gorgias.loading && !disabled, [gorgias]);

  const performAction = (value) => {
    setDisabled(isEmpty(value));
  };

  const onSubmit = (props) => {
      const { id } = getCurrentUser();
      const params = { redirectUrl: callbackUrl + "?account=" + props.subdomain + "&partner=gorgias", subdomain: props.subdomain, userId: id };
      dispatch(gorgiasAuthActions.initOauth(params));
  };

  useEffect(() => {
    dispatch(msgSourceActions.getMsgSourceLink('gorgias'))
  }, []);

  return(
      <Box sx={modalInnerStyles.container}>
        <Box sx={modalInnerStyles.description}>
          {description}
        </Box>

        <form name="gorgiasForm" onSubmit={ handleSubmit(onSubmit) }>
          <Field
            name={'subdomain'}
            component={SubdomainInput}
            channelDomain={channelDomain}
            placeholder={'Subdomain'}
            performAction={performAction}
          />

          <SetupModalFooter
            extraInfoLabel={extraInfoLabel}
            openInNewTab={openInNewTab}
            buttonLabel={buttonLabel}
            disabled={loading || disabled}
            loading={loading}
          />
        </form>
      </Box>
  )
}

const formConfig = {
  form: 'gorgiasForm',
};

export default reduxForm(formConfig)(GorgiasSetupForm);